import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import SeasonType from "./actionTypes"

import SeasonAction from "./actions"
import moment from "moment"
import SeasonAPI from "helpers/season_backend_helper"

function* fetchListOnPage({ payload }) {
  yield put(
    SeasonAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(SeasonAPI.getListPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      SeasonAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      SeasonAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetail({ payload, action }) {
  yield put(
    SeasonAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(SeasonAPI.getDetail, payload.id)

    action(data)
    yield put(
      SeasonAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      SeasonAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPostData({ payload, action }) {
  yield put(
    SeasonAction.postDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    payload.closingDate = moment(payload.closingDate).format("YYYY-MM-DD")
    payload.paymentDate = moment(payload.paymentDate).format("YYYY-MM-DD")
    let { data } = yield call(SeasonAPI.postData, payload)

    yield put(
      SeasonAction.postDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      SeasonAction.postDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutData({ payload, action }) {
  yield put(
    SeasonAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(SeasonAPI.putData, payload)

    yield put(
      SeasonAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      SeasonAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchList({ payload }) {
  yield put(
    SeasonAction.getListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(SeasonAPI.getList)
    yield put(
      SeasonAction.getListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      SeasonAction.getListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* seasonSaga() {
  yield takeEvery(SeasonType.GET_SEASON_PAGES, fetchListOnPage)
  yield takeEvery(SeasonType.GET_DETAIL_SEASON_BY_ID, fetchDetail)
  yield takeEvery(SeasonType.POST_SEASON, fetchPostData)
  yield takeEvery(SeasonType.PUT_SEASON, fetchPutData)
  yield takeEvery(SeasonType.GET_SEASON_LIST, fetchList)
}

export default seasonSaga
